<template>
  <v-card class="mx-auto" color="grey lighten-4" max-width="600">
    <v-stepper v-model="step" class="elevation-0 grey lighten-4">
      <v-card-title>
        <v-layout flex row>
          <h1 class="font-weight-bold pt-1 secondary--text">Nova promoção</h1>
        </v-layout>
      </v-card-title>
      <v-toolbar dense dark color="secondary">
      <v-card-text
        class="text-xs-center title font-weight-medium white--text mb-2 pb-0"
      >Cadastrando nova promoção</v-card-text>
      </v-toolbar>
      <v-stepper-items>
        <v-stepper-content class="pa-0 ma-0" step="1">
          <v-container grid-list-md>
            <v-form lazy-validation v-model="valid1" ref="formFirstStep">
              <v-layout row wrap>
                <v-flex xs12 class="pa-0 ma-0 mt-2">
                  <v-text-field
                    :disabled="!tem_desconto_em_reais || (posto && posto.tipo_desconto !== 2)"
                    id="reais"
                    label="Valor de Desconto"
                    v-money="money"
                    v-model.lazy="desconto_em_reais"
                    hint="Valor a ser subtraido do valor do item"
                    :rules="tem_desconto_em_reais ? [
                      () => cadOferta.desconto_em_reais > 0 || 'O desconto da oferta deve ser de no mínimo R$ 0,01 Centavo',
                      () => cadOferta.desconto_em_reais <= 4 || 'O valor máximo de desconto de uma oferta R$ 4,00',
                      (v) => !!v || 'Desconto inválido',
                    ] : []"
                  />
                </v-flex>
                <v-flex xs12 class="ma-0 pa-0">
                  <v-text-field
                    :disabled="tem_desconto_em_reais"
                    v-model="desconto"
                    label="Percentual do desconto"
                    required
                    suffix="%"
                    id="percentual"
                    :rules="!tem_desconto_em_reais ? [
                      () => cadOferta.percentual_desconto > 0 || 'O desconto da oferta deve ser de, no mínimo, 0%',
                      () => cadOferta.percentual_desconto <= 100 || 'Desconto inválido',
                      (v) => !!v || 'Desconto inválido',
                    ] : []"
                    hint="Percentual a ser subtraido do valor do item"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="posto && (posto.rede_sindicato || posto.is_white_label)" class="ma-0 pa-0">
                  <span>
                    App Destinado
                  </span>
                  <v-select
                      label="App Destinado"
                      v-model="appSelecionado"
                      :items="appList"
                      item-text="text"
                      item-value="value"
                      hide-details
                      single-line
                    />
                </v-flex>
                <v-flex
                  aling-self-center
                  style="
                      justify-content: center;
                      display: flex;
                  "
                  class="ma-0 pa-0"
                  v-if="planos.length > 0"
                >
                  <v-tooltip bottom>
                    <v-switch class="mr-4" slot="activator" v-model="cadOferta.para_assinantes" color="secondary">
                      <template v-slot:label>
                          Para Assinantes
                      </template>
                    </v-switch>
                    <span style="font-size: 1.2em;">
                      {{
                        !cadOferta.para_assinantes ?
                        'Ativando essa função, A promoção estará disponível para os assinantes do programa de assinatura.' :
                        'Ao Desativar essa função a promoção estará disponível para todos os clientes que comprarem em seu posto'
                      }}
                    </span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-switch class="mr-4" slot="activator" v-model="tem_desconto_em_reais" :disabled="posto && posto.tipo_desconto !== 2" color="secondary">
                      <template v-slot:label>
                        Tem Desconto em Reais
                      </template>
                    </v-switch>
                    <span style="font-size: 1.2em;">
                      {{
                        !tem_desconto_em_reais ?
                        'Ativando essa função, A promoção oferecerá o desconto em reais ao invés de um percentual. (Ex: R$ 0,15 de desconto)' :
                        'Ao Desativar essa função a promoção oferecerá o desconto na forma de percentual. (Ex: 2% de desconto)'
                      }}
                    </span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs12 class="ma-0 pa-0">
                  <span>Categoria:</span>
                  <v-select
                    label="Selecione a categoria"
                    :items="categorias"
                    item-text="nome"
                    item-value="id"
                    v-model="cadOferta.categoria"
                    hide-details
                    single-line
                  />
                </v-flex>
                <v-flex xs12 class="ma-0 pa-0 mt-4">
                  <span>Item:</span>
                  <v-select
                    label="Para"
                    :items="todos_itens"
                    item-text="nome"
                    item-value="id"
                    v-model="cadOferta.item"
                    hide-details
                    single-line
                    clearable
                  />
                </v-flex>
                <template v-if="cadOferta.item === 0">
                  <v-flex xs12 class="mt-3">
                    <h2 class="text-xs-center secondary--text mb-3" style="font-weight: normal;">
                      Selecione os itens que não farão parte dessa promoção
                    </h2>
                  </v-flex>
                  <v-flex xs12 class="ma-0 pa-0" style="flex-direction: row; display: flex;">
                    <v-flex xs10 class="pa-0 ma-0">
                      <span>Selecione um Item para remover da promoção</span>
                        <v-select
                          label="Selecione um Item"
                          :items="todos_itens"
                          item-text="nome"
                          v-model="item_list"
                          hide-details
                          single-line
                          return-object
                          clearable
                        />
                    </v-flex>
                    <v-flex xs2 style="justify-content: center; display: flex;" class="pa-0 ma-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn :disabled="item_list === undefined" @click="ListAdd()" v-on="on" icon color="primary" style="margin-top:2.5em;"><v-icon small>add</v-icon></v-btn>
                        </template>
                        Adicionar combustível a lista
                      </v-tooltip>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 class="ma-0 pa-0">
                    <v-layout justify-center wrap>
                      <v-flex xs12 class="mt-3">
                        <h3 style="text-align: center;" class="grey--text" v-if="itens_nao_ofertados.length > 0">Combustíveis que não serão ofertados</h3>
                      </v-flex>
                      <v-flex xs12>
                        <v-list style="background-color:#F5F5F5">
                          <v-list-tile v-for="(ino, index) in itens_nao_ofertados" :key="index">
                            <v-list-tile-avatar>
                              <svg-filler
                                v-if="ino.categoria.referencia === 'combustivel'"
                                :path="ino.combustivel.icone ? require(`@/assets/combs/${ino.combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                                width="30px"
                                height="30px"
                                :fill="ino.preco ? ino.combustivel.color : 'grey'"
                              />
                              <v-icon v-else :color="ino.categoria.cor">
                                {{ ino.categoria.icone }}
                              </v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ino.nome}}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-btn icon @click="removerDalista(index)">
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </template>
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-0">
          <v-container grid-list-md>
            <v-form lazy-validation v-model="valid2" ref="formSecondStep">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-menu
                    ref="menuInicio"
                    v-model="menuInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="cadOferta.data_inicio"
                        label="Início"
                        hint="Início da promoção"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        @blur="date_inicio = parseDate(cadOferta.data_inicio)"
                        v-on="on"
                        required
                        :rules="[
                          (v) => !!v || 'A data inicial é obrigatória'
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date_inicio"
                      no-title
                      @input="menuInicio = false"
                      locale="pt-br"
                      :allowed-dates="(date) => {
                        return Date.parse(date) >= today
                      }"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="cadOferta.data_fim"
                        label="Fim"
                        hint="Fim da promoção"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        @blur="date = parseDate(cadOferta.data_fim)"
                        v-on="on"
                        required
                        :rules="[
                          (v) => !!v || 'A data final é obrigatória'
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="date"
                    no-title
                    @input="menu = false"
                    locale="pt-br"
                    :allowed-dates="(date) => {
                        return Date.parse(date) >= data_inicio_teste
                    }"
                    />
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
      <v-card-actions>
        <v-btn color="grey" flat @click="voltarTela()">
          <template v-if="step === 1">CANCELAR</template>
          <template v-else>VOLTAR</template>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat @click="continuarTela()" :disabled="disabled">
          <template v-if="step === 4">CONFIRMAR</template>
          <template v-else>CONTINUAR</template>
        </v-btn>
      </v-card-actions>
    </v-stepper>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  data () {
    return {
      step: 1,
      opcao: 'Posto',
      rede: undefined,
      valid1: false,
      valid2: false,
      valid4: false,
      renderComponent: true,
      date: null,
      limitar_pagamento: false,
      tipo_pagamento: null,
      date_inicio: null,
      menu: false,
      menuInicio: false,
      desconto: 0,
      planos: [],
      itens_nao_ofertados: [],
      todos_itens: [],
      categorias: [],
      item_list: undefined,
      appSelecionado: 1,
      tem_desconto_em_reais: false,
      desconto_em_reais: '0,00',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      cadOferta: {
        percentual_desconto: null,
        desconto_em_reais: null,
        promocao: true,
        data_inicio: null,
        data_fim: null,
        today: null,
        data_inicio_teste: null,
        para_assinantes: false,
        id_rede: null,
        combustiveis_nao_ofertados: [],
        itens_nao_ofertados: [],
        categoria: 0,
        disponivel: true,
        item: 0,
        novo: true
      }
    }
  },
  watch: {
    limitar_pagamento (val) {
      if (!val) {
        this.tipo_pagamento = null
      }
    },
    date (val) {
      this.cadOferta.data_fim = this.formatDate(this.date)
    },
    date_inicio (val) {
      this.cadOferta.data_inicio = this.formatDate(this.date_inicio)
      this.data_inicio_teste = Date.parse(val)
    },
    desconto (val) {
      if (val) {
        this.cadOferta.percentual_desconto = val
      }
    },
    tipo_pagamento (val) {
      this.cadOferta.tipos_pagamento = []
      if (val) {
        this.cadOferta.tipos_pagamento.push(val)
      }
    },
    'cadOferta.item' (val) {
      if (val !== 0) {
        this.itens_nao_ofertados = []
      }
    },
    'cadOferta.categoria' () {
      this.pegarTodosItens()
    },
    tem_desconto_em_reais (val) {
      if (val) {
        this.cadOferta.desconto_em_reais = '0,00'
        this.cadOferta.percentual_desconto = null
      } else {
        this.cadOferta.percentual_desconto = 0
        this.cadOferta.desconto_em_reais = null
      }
      this.verificarOferta(true)
    },
    desconto_em_reais (val) {
      if (val !== '0,00' && this.tem_desconto_em_reais) {
        this.cadOferta.desconto_em_reais = this.formatarValor(val)
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    tiposPagamento () {
      return this.$store.getters.tiposPagamento
    },
    disabled () {
      if (!this.cadOferta.categoria) return true
      else if (!this.tem_desconto_em_reais && (this.cadOferta.percentual_desconto < 1 || this.cadOferta.percentual_desconto > 100)) return true
      else if (this.tem_desconto_em_reais && (this.cadOferta.desconto_em_reais <= 0 || this.cadOferta.desconto_em_reais >= 4)) return true
      return false
    },
    appList () {
      const LISTA = []
      if (!this.posto) return LISTA
      if (((this.posto.rede_sindicato && this.posto.is_white_label) ||
          ((this.posto.rede_sindicato || this.posto.is_white_label) &&
          this.posto.is_simultaneo)) &&
          !this.posto.exclusive_to_white_label && !this.posto.exclusive_to_union
      ) {
        LISTA.push({ text: 'Apetrus', value: 1 })
      } if (this.posto.is_white_label) LISTA.push({ text: 'App do Posto', value: 2 })
      if (this.posto.rede_sindicato) LISTA.push({ text: 'App do Sindicato', value: 3 })
      return LISTA
    }
  },
  beforeMount () {
    this.pegarCategorias()
    this.today = new Date().toISOString().substr(0, 10)
    this.today = Date.parse(this.today)
    this.pegarPlanos()
    this.pegarTodosItens()
    this.verificarOferta(false)
    this.appSelecionado = this.appList.length > 0 ? this.appList[0].value : 1
  },
  methods: {
    verificarOferta (mostrarError) {
      const data = {}
      if (this.tem_desconto_em_reais) {
        data.percentual_desconto__isnull = false
      } else {
        data.desconto_em_reais__isnull = false
      }
      this.$store.dispatch('verificarOferta', data).then(json => {
        if (json.existe) {
          this.tem_desconto_em_reais = !this.tem_desconto_em_reais
          if (mostrarError) this.$emit('error', 'Você não pode usar oferta ou promoções com desconto em percentual e em reais simultaneamente.')
        }
      })
    },
    fechar () {
      this.$refs.formFirstStep.reset()
      this.$refs.formSecondStep.reset()
      this.limitar_pagamento = false
      this.step = 1
      this.$emit('fechar')
    },
    formatarValor (valor) {
      return Number(valor.replace('R$ ', '').replaceAll('.', '').replace(',', '.'))
    },
    ListAdd () {
      let itemExiste = false
      for (let i in this.itens_nao_ofertados) {
        if (this.itens_nao_ofertados[i].id === this.item_list.id) {
          itemExiste = true
        }
      }
      if (itemExiste) {
        this.$emit('error', 'Esse item já foi inserido.')
      } else {
        this.itens_nao_ofertados.push(this.item_list)
      }
    },
    removerDalista (index) {
      this.itens_nao_ofertados.splice(index, 1)
    },
    pegarPlanos () {
      const data = { ativo: true }
      data.cnpj = this.posto.cnpj
      this.$store.dispatch('pegarPlanos', data).then(json => {
        this.planos = json
      })
    },
    continuarTela () {
      switch (this.step) {
        case 1:
          if (this.$refs.formFirstStep.validate()) {
            this.step++
          }
          break
        case 2:
          if (this.$refs.formSecondStep.validate()) {
            this.confirmar()
          }
      }
    },
    voltarTela () {
      switch (this.step) {
        case 1:
          this.fechar()
          break
        default:
          this.step--
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    confirmar () {
      if (
        !this.tem_desconto_em_reais && (this.cadOferta.percentual_desconto < 0 ||
        this.cadOferta.percentual_desconto > 100 || this.cadOferta.percentual_desconto === '')
      ) {
        this.$emit('error', 'Percentual de desconto inválido.')
        return
      }

      if (
        this.tem_desconto_em_reais && this.cadOferta.desconto_em_reais <= 0
      ) {
        this.$emit('error', 'O valor do desconto em reais é inválido.')
        return
      }

      if (this.cadOferta.item === 0 && this.itens_nao_ofertados.length > 0) {
        this.cadOferta.itens_nao_ofertados = []
        this.cadOferta.combustiveis_nao_ofertados = []
        this.itens_nao_ofertados.map(
          (ino) => {
            if (ino.categoria.referencia === 'combustivel') {
              this.cadOferta.combustiveis_nao_ofertados.push(ino.combustivel.id_combustivel)
            } else {
              this.cadOferta.itens_nao_ofertados.push(ino.id)
            }
          }
        )
      }

      const body = {
        ...this.cadOferta,
        data_fim: this.parseDate(this.cadOferta.data_fim),
        data_inicio: this.parseDate(this.cadOferta.data_inicio),
        item: this.cadOferta.item === 0 ? null : this.cadOferta.item,
        categoria: this.cadOferta.categoria,
        posto: this.posto.cnpj,
        percentual_desconto: this.tem_desconto_em_reais ? null : this.cadOferta.percentual_desconto,
        desconto_em_reais: this.tem_desconto_em_reais ? this.cadOferta.desconto_em_reais : null,
        appSelecionado: this.appSelecionado
      }

      this.$store.dispatch('ofertas', {
        method: 'POST',
        body: body
      })
        .then(() => {
          this.$emit('showMessage', 'Promoção cadastrada com sucesso')
          this.$emit('carregar')
          this.fechar()
        })
        .catch(() => {
          this.$emit('error', 'Não foi possível inserir a promoção')
          this.fechar()
        })
    },
    pegarCategorias () {
      this.$store.dispatch('pegarCategorias').then(json => {
        this.categorias = json
        if (json.length > 0) this.cadOferta.categoria = json[0].id
      })
    },
    pegarTodosItens () {
      const data = {
        method: 'GET',
        parameters: {
          posto: this.posto.cnpj
        }
      }
      if (this.cadOferta.categoria) {
        data.parameters.categoria = this.cadOferta.categoria
      }
      this.$store.dispatch('itens', data).then(json => {
        this.todos_itens = json
      })
    }
  },
  directives: { money: VMoney }
}
</script>
